var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pdf",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.516,
    height: 26.127,
    viewBox: "0 0 21.516 26.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11036",
    "data-name": "Path 11036",
    d: "M22.094,0h13.4l6.351,7.765V24.4a1.748,1.748,0,0,1-1.765,1.731H22.094A1.748,1.748,0,0,1,20.329,24.4V1.731A1.748,1.748,0,0,1,22.094,0Z",
    transform: "translate(-20.329 0)",
    fill: "#e24c3f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11037",
    "data-name": "Path 11037",
    d: "M209.333,8.19h-4.595a1.782,1.782,0,0,1-1.781-1.781V.193Z",
    transform: "translate(-187.842 -0.175)",
    fill: "#b53629"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11038",
    "data-name": "Path 11038",
    d: "M98.9,136.445a.519.519,0,0,0,0-1.025H97.231a.528.528,0,0,0-.509.579v4.176c0,.372.209.579.491.579s.49-.207.49-.579v-1.146h1.012a.48.48,0,0,0,.471-.52.471.471,0,0,0-.471-.506H97.7v-1.558Zm-5.654-1.025H92.026a.546.546,0,0,0-.568.575v4.183a.543.543,0,0,0,.582.56h1.284a2.4,2.4,0,0,0,2.524-2.584A2.465,2.465,0,0,0,93.249,135.42Zm.059,4.287h-.746v-3.256h.673c1.018,0,1.461.694,1.461,1.651C94.7,139,94.26,139.707,93.308,139.707Zm-4.484-4.287H87.612a.515.515,0,0,0-.534.579v4.176a.517.517,0,1,0,1.027,0v-1.219h.76a1.673,1.673,0,0,0,1.712-1.761A1.693,1.693,0,0,0,88.824,135.42Zm-.02,2.556h-.7V136.4h.7a.792.792,0,0,1,0,1.575Z",
    transform: "translate(-82.448 -123.38)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.5627951f.svg";
export { ForwardRef as ReactComponent };